export enum Permission {
  USERS_VIEW = 'user-management:view',
  USERS_MANAGE = 'user-management:manage',
  ALERTS_VIEW = 'alerts:view',
  ALERTS_MANAGE = 'alerts:manage',
  AUDIT_LOG_VIEW = 'audit-log:view',
  TRANSACTIONS_VIEW = 'transactions:view',
  TRANSACTIONS_MANAGE = 'transactions:manage',
  DATA_COLLECTION_VIEW = 'data-collection:view',
  WAREHOUSE_VIEW = 'warehouse:view',
  WAREHOUSE_MANAGE = 'warehouse:manage',
  INVENTORY_VIEW = 'inventory:view',
  INVENTORY_MANAGE = 'inventory:manage',
  INTEGRATIONS_VIEW = 'integrations:view',
  INTEGRATIONS_MANAGE = 'integrations:manage',
  FORECAST_VIEW = 'forecast:view',
  FORECAST_MANAGE = 'forecast:manage',
  ADMIN = 'admin',
  SUPPLY_NETWORK_VIEW = 'supply-network:view',
  SUPPLY_NETWORK_MANAGE = 'supply-network:manage',
  SUPPLIER_PERFORMANCE_VIEW = 'supplier-performance:view',
  SHIPPING_VIEW = 'shipping:view',
  SHIPPING_MANAGE = 'shipping:manage',
}
